module.exports = __webpack_public_path__ + "static/img/icon_game_9.b74f9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_9.png
// module id = 2OVG
// module chunks = 0